import React, { FC } from 'react';

import { PRODUCT_NAME } from 'src/apps/dashboard/pages/issues/types/IssuesTypes';
import { WebSdkDetailsBlock } from 'src/apps/web-sdks/components/WebSdkDetailsBlock';
import { WfaDetailsBlock } from 'src/apps/wfa/components/WfaDetailsBlock';

import { MobileDashboardDetailsBlock } from './MobileDashboardDetailsBlock';

interface IUniqueIssuesDetailsBlockProps {
	runId: string;
	issueId: string;
	productName: PRODUCT_NAME;
	setError: (msg: string) => void;
}

export const UniqueIssuesDetailsBlock: FC<IUniqueIssuesDetailsBlockProps> = ({
	runId,
	issueId,
	productName,
	setError
}) => {
	if (productName === PRODUCT_NAME.WEB_FLOW_ANALYZER) {
		return <WfaDetailsBlock runId={runId} issueId={issueId} setError={setError} />;
	}

	if (
		productName === PRODUCT_NAME.MOBILE_FLOW_ANALYZER ||
		productName === PRODUCT_NAME.MOBILE_SDK
	) {
		return (
			<MobileDashboardDetailsBlock
				runId={runId}
				issueId={issueId}
				productName={productName}
				setError={setError}
			/>
		);
	}

	return <WebSdkDetailsBlock runId={runId} issueId={issueId} setError={setError} />;
};
